import { CarouselButton, Column, Container, Grid, Row, Separator, useAlignments, useSizes } from 'metrix-common3';
import styled from 'styled-components';

const ButtonContainer = styled(Container)`
    overflow: hidden;
`;

const Footer = (props) => {
    const alignments = useAlignments();
    const sizes = useSizes();

    return (
        <Grid>
            <Row noguttertop>
                <Column>
                    <Separator solid />
                </Column>
            </Row>
            <Row>
                <Column>
                    <ButtonContainer
                        inline
                        fullSize
                        horizontalAlignment={alignments.right}
                        verticalAlignment={alignments.center}
                    >
                        {props.query.triage.skip > 0 && (
                            <CarouselButton
                                direction='left'
                                clickEvent={() => {
                                    props.doReduceQueryElement({ code: 'search', value: true });
                                    props.doReduceQueryElement({ code: 'skip', value: props.query.triage.skip - 25 });
                                    props.doQueryTriagePolicies();
                                }}
                            />
                        )}
                        {props.incompletePolicies?.length === 25 && (
                            <CarouselButton
                                direction='right'
                                left={sizes.xs}
                                clickEvent={() => {
                                    props.doReduceQueryElement({ code: 'search', value: true });
                                    props.doReduceQueryElement({ code: 'skip', value: props.query.triage.skip + 25 });
                                    props.doQueryTriagePolicies();
                                }}
                            />
                        )}
                    </ButtonContainer>
                </Column>
            </Row>
        </Grid>
    );
};

export default Footer;
